import { selectDoc, event, selectAll, addClass } from "../utils/utils";

export class SortBlog {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.dropDownItem = selectAll("[data-sort]");
    this.dropDownItemMobile = selectAll("[data-sort-mobile]");
    this.dropDownInput = selectDoc("[data-sort-input]");
    this.dropDownTag = selectDoc("[data-sort-tag]");
    this.dropDownMobile = selectDoc("[data-blog-sort]");
    this.handleBlog = selectDoc("[data-blog-filters]");

  }

  render() {
    this.selectedSort();
    this.a11ySelect();
    if (window.innerWidth < 768) {
      this.mobileSort();
    } else {
      this.desktopSort();
    }
  }

  mobileSort = () => {
    const handleBlog = this.handleBlog;
    this.dropDownMobile.addEventListener("change", function (e) {
      const valueM = e.target.value;
      const currentUrl = window.location.origin;
      const handle = handleBlog.getAttribute("data-blog-filters");
      if (valueM === "all") {
        const url = `${currentUrl}/blogs/${handle}`
        window.location = (url)
      } else {
        const url = `${currentUrl}/blogs/${handle}/tagged/${valueM}`
        window.location = (url)
      }
      sessionStorage.setItem("valueMobile", valueM);
    });
  };

  desktopSort = () => {
    const handleBlog = this.handleBlog;
    const dropDownItem = this.dropDownItem;
    for (var i = 0; i < dropDownItem.length; i++) {
      dropDownItem[i].addEventListener("click", function () {
        const value = this.getAttribute("data-sort-by").toLowerCase();
        const tag = this.innerHTML;
        const currentUrl = window.location.origin;
        const handle = handleBlog.getAttribute("data-blog-filters");
        if (value === "all") {
          const url = `${currentUrl}/blogs/${handle}`
          window.location = (url)
        } else {
          const url = `${currentUrl}/blogs/${handle}/tagged/${value}`
          window.location = (url)
        }
        sessionStorage.setItem("tag", tag);
        sessionStorage.setItem("value", value);
      });
    }
  };

  selectedSort = () => {
    const selectedFilterTag = sessionStorage.getItem("tag");
    const selectedFilterValue = sessionStorage.getItem("value");
    const selectedFilterMobile = sessionStorage.getItem("valueMobile");

    if (selectedFilterTag) {
      this.dropDownInput.textContent = selectedFilterTag;
      this.dropDownTag.textContent = selectedFilterTag;
    }

    const dropDownItem = this.dropDownItem;
    for (var i = 0; i < dropDownItem.length; i++) {
      const id = dropDownItem[i].getAttribute("data-sort-by");
      if (id === selectedFilterValue) {
        addClass(dropDownItem[i], "active");
      }
    }

    const dropDownItemMobile = this.dropDownItemMobile;
    for (var i = 0; i < dropDownItemMobile.length; i++) {
      const value = dropDownItemMobile[i].value;
      if (value === selectedFilterMobile) {
        dropDownItemMobile[i].selected = 'selected'
      }
    }

    if (selectedFilterTag || selectedFilterValue) {
      setTimeout(() => {
        sessionStorage.clear();
      }, 1000);
    }
  };

  a11ySelect = () => {
    const ENTER_KEY_CODE = 13;
    const DOWN_ARROW_KEY_CODE = 40;
    const UP_ARROW_KEY_CODE = 38;
    const ESCAPE_KEY_CODE = 27;

    const list = document.querySelector(".dropdown__list");
    const listContainer = document.querySelector(".dropdown__list-container");
    const dropdownArrow = document.querySelector(".dropdown__arrow");
    const listItems = document.querySelectorAll(".dropdown__list-item");
    const dropdownSelectedNode = selectDoc("[data-sort-input]");

    const closeDropdown = selectDoc("[close-select]");
    const listItemIds = [];

    dropdownSelectedNode.addEventListener("click", (e) =>
      toggleListVisibility(e)
    );
    dropdownSelectedNode.addEventListener("keydown", (e) =>
      toggleListVisibility(e)
    );

    listItems.forEach((item) => listItemIds.push(item.id));

    listItems.forEach((item) => {
      item.addEventListener("keydown", (e) => {
        switch (e.keyCode) {
          case ENTER_KEY_CODE:
            closeList();
            const value = item.getAttribute("data-sort-by");
            clickSort(value);
            return;

          case DOWN_ARROW_KEY_CODE:
            focusNextListItem(DOWN_ARROW_KEY_CODE);
            return;

          case UP_ARROW_KEY_CODE:
            focusNextListItem(UP_ARROW_KEY_CODE);
            return;

          case ESCAPE_KEY_CODE:
            closeList();
            return;

          default:
            return;
        }
      });
    });

    function clickSort(value) {
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    }

    event(closeDropdown, "click", closeList);

    function closeList() {
      list.classList.remove("open");
      dropdownArrow.classList.remove("expanded");
      listContainer.setAttribute("aria-expanded", false);
    }

    function toggleListVisibility(e) {
      let openDropDown = e.keyCode === ENTER_KEY_CODE;

      if (e.keyCode === ESCAPE_KEY_CODE) {
        closeList();
      }

      if (e.type === "click" || openDropDown) {
        list.classList.toggle("open");
        dropdownArrow.classList.toggle("expanded");
        listContainer.setAttribute(
          "aria-expanded",
          list.classList.contains("open")
        );
      }

      if (e.keyCode === DOWN_ARROW_KEY_CODE) {
        focusNextListItem(DOWN_ARROW_KEY_CODE);
      }

      if (e.keyCode === UP_ARROW_KEY_CODE) {
        focusNextListItem(UP_ARROW_KEY_CODE);
      }
    }

    function focusNextListItem(direction) {
      const activeElementId = document.activeElement.id;
      if (activeElementId === "dropdown__selected") {
        document.querySelector(`#${listItemIds[0]}`).focus();
      } else {
        const currentActiveElementIndex = listItemIds.indexOf(activeElementId);
        if (direction === DOWN_ARROW_KEY_CODE) {
          const currentActiveElementIsNotLastItem =
            currentActiveElementIndex < listItemIds.length - 1;
          if (currentActiveElementIsNotLastItem) {
            const nextListItemId = listItemIds[currentActiveElementIndex + 1];
            document.querySelector(`#${nextListItemId}`).focus();
          }
        } else if (direction === UP_ARROW_KEY_CODE) {
          const currentActiveElementIsNotFirstItem =
            currentActiveElementIndex > 0;
          if (currentActiveElementIsNotFirstItem) {
            const nextListItemId = listItemIds[currentActiveElementIndex - 1];
            document.querySelector(`#${nextListItemId}`).focus();
          }
        }
      }
    }

    document.addEventListener(
      "click",
      function (event) {
        if (event.target.closest(".dropdown")) {
          return;
        }
        closeList();
      },
      false
    );
  };
}
